// Anillo de foco de teclado común: blue-600 en claro y blue-400 en oscuro
// pasan 3:1 contra los fondos de la app (WCAG 1.4.11); el ring de Tailwind
// usa box-shadow, así que se ve aunque el elemento lleve outline-none.
export const FOCO = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 dark:focus-visible:ring-blue-400';

// Props para un elemento que no es <button> pero se activa con clic (Card,
// zona de arrastre, monto en modo privado): lo hace tabulable y le da
// Enter/Espacio. Con onActivar vacío no añade nada, para que el elemento
// siga siendo texto normal cuando no hay acción.
export function activable(onActivar, { label, pressed } = {}) {
  if (!onActivar) return {};
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivar,
    onKeyDown: (e) => {
      if (e.target !== e.currentTarget) return; // no robar Enter/Espacio a un control hijo
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onActivar(e); }
    },
    ...(label ? { 'aria-label': label } : {}),
    ...(pressed !== undefined ? { 'aria-pressed': pressed } : {}),
  };
}
